import { Box, Chip, Tooltip, Typography } from "@mui/material";
import React from "react";
import { IModifyUser } from "ui/Scripts/source/models/user/modifyUser";

interface ITaskListHandlersColProps {
    handlers: IModifyUser[];
}

export const TaskListHandlersCol = (props: ITaskListHandlersColProps) => {
    const otherHandlers = props.handlers.length > 1 ? props.handlers.slice(1) : [];

    return (
        <Tooltip title={otherHandlers.map(i => i.name).join(", ")}>
            <Box display="flex" alignItems="center" sx={{ overflow: "hidden" }}>
                {props.handlers.length > 0 &&
                    <Typography variant="body2" sx={{ overflow: "hidden", textOverflow: "clip", whiteSpace: "nowrap" }}>{props.handlers[0].name}</Typography>
                }
                {otherHandlers.length > 0 &&
                    <Chip color="info" label={"+" + otherHandlers.length.toString(10)} size="small" sx={{ marginLeft: "8px" }} />
                }
            </Box>
        </Tooltip>
    );
};
